/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import StatsReports from "../statsReports";
import { Controller, useForm } from "react-hook-form";
import HubInputField from "src/components/inputType";
import Select, { GroupBase, OptionsOrGroups } from "react-select";
import { format, parse } from "date-fns";
import { TerritoriesPropsType, TerritoriesSearchProps } from "./types";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
const TerritoriesFilter: FC<TerritoriesPropsType> = ({
  updateQueryParams,
  defaultQueryParams,
}): JSX.Element => {
  const { control, handleSubmit, getValues, watch } = useForm<TerritoriesSearchProps>({
    mode: "all",
    defaultValues: defaultQueryParams,
  });

  const start_date = watch("start_date")
  const end_date = watch("end_date")
//   const timeData = [
//     { value: "day", label: "Day" },
//     { value: "week", label: "Week" },
//     { value: "month", label: "Month" },
//     { value: "quarter", label: "Quarter" },
//   ];
//   // const periodData = [
//   //   { value: 'period', label: 'vs Previous Period' },
//   //   { value: 'year', label: 'vs Previous Year' },
//   // ]
//   const filterCaseData = [
//     { value: "all", label: "All Cases" },
//     { value: "ecrall", label: "ECR Cases" },
//     { value: "ncrall", label: "Non-ECR Cases" },
//     { value: "parecrall", label: "PA Pending" },
//     { value: "ncrparall", label: "Missing Docs" },
//   ];
  const periodData = [
    { value: "day", label: "Group by Day" },
    { value: "week", label: "Group by Week" },
    { value: "month", label: "Group by Month" },
    { value: "quarter", label: "Group by Quarter" },
  ];

  const CompareFilterData = [
    { value: "p-1", label: "Compare With Previous Period" },
    { value: "y-1", label: "Compare With Previous Year" },

  ];

    // const clearFormData = () => {
    //     const values = {
    //         start_date: format(
    //             new Date().setDate(new Date().getDate() - 30),
    //             "yyyy-MM-dd"
    //         ),
    //         end_date: format(
    //             new Date().setDate(new Date().getDate()),
    //             "yyyy-MM-dd"
    //         ),
    //         period: "",
    //         filter: "",
    //         type: defaultQueryParams?.type,
    //         role: defaultQueryParams?.role,
    //         id: defaultQueryParams?.id,
    //         search_str:"",
    //         str:""
    //     };

    //     reset(values);
    //     updateQueryParams(getValues(), true);
    // };

  const searchForStats = (values: TerritoriesSearchProps) => {
    const updatedValues = {
      ...values,
      period: values.period
        ? typeof values.period === "string"
          ? values.period
          : (values.period as unknown as { value: string; label: string }).value
        : "",
      // period:
      //   values.period ?
      //     (typeof values.period === "string" ? values.period : (values.period as unknown as { value: string; label: string; }).value)
      //     : "",
      filter_type: values.filter_type
        ? typeof values.filter_type === "string"
          ? values.filter_type
          : (values.filter_type as unknown as { value: string; label: string }).value
        : "",
    };

    updateQueryParams(updatedValues, false);
  };

  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="card mt-4">
        <div className="card-header">
          <h4 className="m-0">Statistics</h4>
        </div>
        <div className="card-body px-3 pt-3">
          <div className="row g-3 statistics-filter">
            <div className="col min-col">
              <Controller
                name="start_date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <div className="row">
                    <label htmlFor="start_date" className="form-label col-lg-4 col-md-4 col-12 pe-0">Start Date</label>
                    <div className="col-lg-8 col-md-8 col-12">
                      <div className="position-relative">
                        <DatePicker
                          id="start_date"
                          selected={field.value ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                          onChange={(val) => val ? field.onChange(format(val, "yyyy-MM-dd")) : null}
                          className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
                          placeholderText="mm/dd/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          customInput={
                            <ReactInputMask mask="99/99/9999">
                              {(inputProps: {}) => <input {...inputProps} />}
                            </ReactInputMask>
                          }
                          maxDate={end_date ? new Date(end_date) : undefined}
                        />
                        <i
                          className="bi bi-calendar position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>
            <div className="col min-col">
              <Controller
                name="end_date"
                control={control}
                defaultValue=""
                render={( { field } ) => (
                  <div className="row">
                    <label htmlFor="end_date" className="form-label col-lg-4 col-md-4 col-12 pe-0">End Date</label>
                    <div className="col-lg-8 col-md-8 col-12">
                      <div className="position-relative">
                        <DatePicker
                          id="end_date"
                          selected={field.value ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                          onChange={(val) => val ? field.onChange(format(val, "yyyy-MM-dd")) : null}
                          className="form-control form-control-datepicker rounded-1" wrapperClassName="w-100"
                          placeholderText="mm/dd/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          customInput={
                            <ReactInputMask mask="99/99/9999">
                              {(inputProps: {}) => <input {...inputProps} />}
                            </ReactInputMask>
                          }
                          minDate={start_date ? new Date(start_date) : undefined}
                        />
                        <i
                          className="bi bi-calendar position-absolute"
                          style={{
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>
            <div className="col min-col">
              <Controller
                name="period"
                control={control}
                defaultValue={periodData[ 0 ].value}
                render={( { field } ) => (
                  <Select
                    isClearable={true}
                    options={
                      (periodData && periodData.length > 0
                        ? periodData.map((item) => ({
                          value: item.value,
                          label: item.label,
                        }))
                        : []
                      ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                    id="time"
                    {...field}
                    placeholder={'Group by Day'}
                  />
                )}
              />
            </div>
            <div className="col min-col">
              <Controller
                name="filter_type"
                control={control}
                render={({ field }) => (
                  <Select
                    isClearable={true}
                    options={
                      ( CompareFilterData && CompareFilterData.length > 0
                        ? CompareFilterData.map( ( item ) => ( {
                          value: item.value,
                          label: item.label,
                        } ) )
                        : [] ) as unknown as OptionsOrGroups<
                          string,
                          GroupBase<string>
                        >
                    }
                    id="filter"
                    {...field}
                    placeholder={'Compare With ...'}
                  />
                )}
              />
            </div>
            <div className="col min-col">
              <Controller
                name="str"
                control={control}
                defaultValue=""
                render={( { field } ) => (
                  <HubInputField
                    inputId="str"
                    isRowBased={false}
                    isRequired={false}
                    field={field}
                    inputPlaceholder="Case/Patient ID or Doctor"

                  />
                )}
              />
            </div>
            <div className="col mb-3 ms-auto">
              <button type="submit" className="btn btn-primary w-100">
                <i className="bi bi-arrow-repeat text-white"></i> Refresh
              </button>
            </div>
          </div>
          <StatsReports getValues={getValues} />
        </div>
      </div>
    </form>
  );
};

export default TerritoriesFilter;
